import { TeamSettingsAdminSlack } from "#webapp/src/components/teams-settings/team-settings-admin-form/team-settings-admin-slack";
import React from "react";
import { TeamSections } from "../web-settings";

type Props = {
  teamId: string;
};

export const TeamSlack = ({ teamId }: Props) => {
  return (
    <div cw-id={`web-settings-${TeamSections.Slack}`} className="cw-mb-7">
      <TeamSettingsAdminSlack teamId={teamId} />
    </div>
  );
};
